var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3451_29781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7558 5.63137L13.0203 4.36688C13.2741 4.11295 13.4167 3.76859 13.4167 3.40953C13.4167 3.05046 13.2741 2.7061 13.0203 2.45218L11.548 0.979936C11.2941 0.726022 10.9497 0.583374 10.5906 0.583374C10.2315 0.583374 9.88711 0.726022 9.6332 0.979936L8.36853 2.2446L11.7558 5.63137Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54364 3.06946L1.42021 9.19293C1.22059 9.39258 1.08834 9.64962 1.04196 9.92811L0.59279 12.6284C0.575119 12.7347 0.583059 12.8436 0.615951 12.9462C0.648843 13.0488 0.705737 13.142 0.781906 13.2182C0.858074 13.2944 0.951319 13.3513 1.05389 13.3841C1.15647 13.417 1.26541 13.425 1.37166 13.4073L4.072 12.9581C4.35049 12.9118 4.60753 12.7796 4.80715 12.5799L10.9309 6.45624L7.54364 3.06946Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 13.5626C6.80665 13.5626 6.62119 13.4858 6.48444 13.349C6.3477 13.2123 6.27087 13.0268 6.27087 12.8334C6.27087 12.64 6.3477 12.4546 6.48444 12.3178C6.62119 12.1811 6.80665 12.1042 7.00004 12.1042H12.8334C13.0268 12.1042 13.2122 12.1811 13.349 12.3178C13.4857 12.4546 13.5625 12.64 13.5625 12.8334C13.5625 13.0268 13.4857 13.2123 13.349 13.349C13.2122 13.4858 13.0268 13.5626 12.8334 13.5626H7.00004Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3451_29781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.edc70fef001cf4db5a2143758d1b6f2f.svg";
export { ForwardRef as ReactComponent };